<div class="footer">
  <span style="font-size: 12px">Disclaimer :</span>
  <span style="font-size: 10px; font-style: italic">&nbsp; EY does not intentionally collect any sensitive personal data from you via the Tool. The Tool’s intention is not
    to process such information.</span> | <a style="font-size: 12px; color: white" href={{_global.privacyPath}}>Privacy Policy</a>
</div>